export default "https://cdn-static.gokick.com/assets/1d764bbda6f1db3d5ed96a1ece7edd078534d524/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";